/**
 * Entry point for the `/control` area.
 *
 * This is a separate route tree from the G0 documentation viewer on purpose. The
 * viewer is the approved, already-working artifact; the Business OS is an
 * application. They share the build and the design tokens, nothing else, so the
 * viewer cannot be broken by changes here.
 */

import { Link } from "react-router-dom";
import ControlCenterPage from "@/control/ControlCenterPage";
import { ControlThemeSelect } from "./ControlThemeSelect";
import LoginPage from "@/control/LoginPage";
import { SessionProvider, useSession } from "@/control/SessionContext";
import { PwaUpdateBanner } from "@/pwa/PwaUpdateBanner";
import { usePwa } from "@/pwa/usePwa";

function Gate() {
  const { user, loading } = useSession();
  const shellOn = process.env.REACT_APP_UI_SHELL === "1";
  const fullScreen = shellOn && Boolean(user);
  const pwa = usePwa();

  return (
    <div className={fullScreen ? "bg-background text-foreground" : "min-h-screen bg-background text-foreground"}>
      <PwaUpdateBanner available={pwa.available} onApply={pwa.apply} lang="hr" />
      {(!shellOn || !user) && (
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-4 py-3 sm:px-6">
        <span className="text-sm font-semibold">Radni prostor</span>
        <ControlThemeSelect />
      </div>
      )}
      {loading && !user ? (
        <p className="px-6 py-16 text-sm text-muted-foreground"
           data-testid="control-loading">
          Učitavanje…
        </p>
      ) : user ? (
        <ControlCenterPage />
      ) : (
        <LoginPage />
      )}
      {!fullScreen && (<footer className="border-t border-border px-6 py-4 text-xs text-muted-foreground"><Link to="/documentation" className="underline" data-testid="control-back-to-docs">Tehnička dokumentacija i implementacijski zadaci ↗</Link></footer>)}
    </div>
  );
}

export default function ControlCenterRoute() {
  return (
    <SessionProvider>
      <Gate />
    </SessionProvider>
  );
}
